import React from 'react';
import { Box } from '@mui/material';
import LeadsBoard from './leads/LeadsBoard';
import LeadPanels from './leads/LeadPanels';

// Leads: app users the viewer may work (own leads for an executive; the team, or the
// personal view, for a leader), with the follow-up / callback / payment feeds beneath.
const Leads = () => (
  <Box>
    <LeadsBoard segment="app" />
    <LeadPanels />
  </Box>
);

export default Leads;
